import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2676e0fe")

_pushScopeId("data-v-2676e0fe")
const _hoisted_1 = { class: "p-2 bg-white calendar" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-chevron-left" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-chevron-right" }, null, -1)
const _hoisted_5 = { class: "font-size-12 text-center mt-2" }
const _hoisted_6 = { class: "calendar--days" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "font-size-24 cursor-pointer hover:opacity-75",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onNextOrPrevMonth(-1)))
      }, [
        _hoisted_3
      ]),
      _createVNode("span", null, _toDisplayString(_ctx.currentMonth), 1),
      _createVNode("div", {
        class: "font-size-24 cursor-pointer hover:opacity-75",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onNextOrPrevMonth(1)))
      }, [
        _hoisted_4
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dayLabels, (dayLabel) => {
          return (_openBlock(), _createBlock("div", {
            class: "day-label",
            key: dayLabel
          }, _toDisplayString(dayLabel), 1))
        }), 128))
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(Array.from(Array(_ctx.datesOfMonth.length / 7).keys()), (row) => {
        return (_openBlock(), _createBlock("div", {
          key: row,
          class: "flex items-center h-8 flex-wrap"
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(Array.from(Array(7).keys()), (col) => {
            return (_openBlock(), _createBlock("div", {
              key: col,
              class: ["calendar--cell", {
            selected: _ctx.isSelected(_ctx.datesOfMonth[row * 7 + col]),
            empty: _ctx.datesOfMonth[row * 7 + col] === null,
          }],
              onClick: ($event: any) => (_ctx.onClickDate(_ctx.datesOfMonth[row * 7 + col]))
            }, _toDisplayString(_ctx.datesOfMonth[row * 7 + col]), 11, ["onClick"]))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
})